<div class="task-comment">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          Adjuntar Comentarios / Fotos
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row">
    <div class="col-12 task-comment-content">
      <form *ngIf="form" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="row">
          <div class="col-12">
            <mat-form-field appearance="outline">
              <input matInput name="comment" formControlName="comment" placeholder="Comentario" type="text">
              <!--mat-error *ngIf="submitted && f.comment?.errors?.required">
                Comentario Obligatorio
              </mat-error-->
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <app-file-uploader [fileLimit]="10" [fileAccept]="'image/jpg|image/png|image/jpeg|application/pdf'" [files]="[]"
              (uploading)="onUploading()" (updated)="imagesOnChange($event)">
            </app-file-uploader>

            <i>Selecciona imágenes para cargar al trabajo</i><br>
            <i class="small">Hasta 10 máximo. De seleccionar mayor cantidad, se mostrarán las primeras que
              seleccione.</i>
          </div>
        </div>

        <div class="row">
          <div class="col-12 pt-4">
            <button mat-raised-button type="submit" class="m-0 ml-1 pull-right btn btn-manax" [disabled]="uploading">
              <span *ngIf="uploading" class="spinner-border spinner-border-sm mr-1"></span>
              Guardar
            </button>
            <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-link d-none d-md-inline"
              (click)="dialog.close(false)">
              Cancelar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>